import { render, staticRenderFns } from "./ItemExchange.vue?vue&type=template&id=21aa80fc&"
import script from "./ItemExchange.vue?vue&type=script&lang=js&"
export * from "./ItemExchange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports